<template>
  <div class="root">
    <TableBlock @checkVal="selectVal" ref="tableData" :columns="columns" :action="action" :param="params" :navHeight="277">
      <div class="search">
        <div class="common-items-center" style="white-space: nowrap;">
        <span class="title-key">所在地</span>
        <ProvCty ref="codeAddress" width="120" @getVal="getAddress"></ProvCty>
            <span class="title-key">关键词</span>
            <el-input v-model="params.keyWord" placeholder="请输入项目名称" size="medium"
              style="width: 245px;margin-right:5px"></el-input>
            <!-- <el-select v-model="params.createMode" placeholder="请选择" size="medium" style="width: 120px;margin-right:5px"
              clearable>
              <el-option label="参与过的项目" value="2"></el-option>
              <el-option label="创建的项目" value="1"></el-option>
            </el-select> -->
            <span class="title-key">项目类型</span>
            <el-select v-model="params.projectType" placeholder="请选择" size="medium" style="width: 120px;margin-right:10px"
              clearable>
              <el-option v-for="(item, index) in proType" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-date-picker
                v-model="date.strat"
                type="date"
                @change="stratDate"
                :clearable="false"
                placeholder="选择日期"
                style="width: 160px"
                >
              </el-date-picker>
              -
              <el-date-picker
                v-model="date.end"
                type="date"
                @change="endDate"
                :clearable="false"
                style="width: 160px;margin-right: 10px;"
                placeholder="选择日期">
              </el-date-picker>
          <el-button type="primary" size="medium" @click.native="search">查询</el-button>
          <!-- <el-button type="primary" size="medium" @click.native="add">增加</el-button> -->
          <el-button type="default" size="medium" @click.native="reset">重置</el-button>
          <el-button type="primary" size="medium" @click.native="fileExport">导出</el-button>
      </div>
      </div>
    </TableBlock>
    <add ref="add"></add>
  </div>
</template>

<script>
import {operate} from '@/utils/config'
import axios from 'axios'
import {downFile} from '@/utils/util'
import ProvCty from '@/components/component-PcrIo/index.vue'
import {getDate} from '@/utils/util'
import {columns} from './columns'
import {deleteFun} from '@/utils/httpFun'
import add from './components/block_add.vue'

export default {
  components:{
    ProvCty,
    add
  },
  data() {
    return {
      action: operate.GETPROJECTLIST,
      columns:[],
      date:{
        strat:'',
        end:''
      },
      params:{
        areaAddress: null,
        projectType: null,
        createMode: null,
        keyWord: null,
        startTime:null,
        endTime:null
      },
      proType: [],               // 项目类型列表
      projectList:[],              // 项目集合
    };
  },
  mounted() {
    this.columns = columns(this);

    this.init();
  },
  methods:{
    init(){
      this.getProType();
    },
    search() {
      this.$nextTick(res=>{
           this.$refs.tableData.getDatas() 
       })
    },
    getAddress(ev) {
      console.log('或',ev)
      let arr = [];
      arr.push(ev.AProve.name);
      arr.push(ev.BCity.name);
      arr.push(ev.COunty.name);
      this.params.areaAddress = arr.join(',')
    },
    selectVal(e){
      this.projectList = e;
    },
    add(){
      this.$refs.add.open('add');
    },
    reset(){

      this.$refs.codeAddress.clearBtn()

      this.params = {
        areaAddress: null,
        projectType: null,
        createMode: null,
        keyWord: null,
        startTime:null,
        endTime:null
      }

      this.date = {
        strat:'',
        end:''
      }

      this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
       })
    },
    stratDate(e){
      this.date.strat = e;
      console.log('开始日期',e)
      this.setDate();
    },
    endDate(e){
      this.date.end = e;
      console.log('结束日期',e)
      this.setDate();
    },
    operateShow(index,item){
      console.log('index',index,item)
      if(index == 1){
        this.$bus.$emit('setIsIf',false)
        this.$bus.$emit('setEdits',item);
      }else if(index == 2){
        this.$confirm('是否删除项目?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteFun(operate.DELPROJECT,{
            projectId:item.id
          },res=>{
            console.log('删除项目',res)
            if(res.data)
              this.$message.success('删除成功')
            else
              this.$message.warning('删除失败')
          })

          this.$nextTick(res=>{
            this.$refs.tableData.getDatas() 
        })
        })
      }
    },
    setDate(){
      if(!!!this.date.strat || !!!this.date.end)return;

      let stratTime = new Date(this.date.strat).getTime();
      let endTime = new Date(this.date.end).getTime();

      if(stratTime > endTime){
        this.date = {
          strat:null,
          end:null
        }
        this.$message.warning('日期选择有误 开始时间不能小于结束时间')
        return;
      }

      this.params.startTime = getDate(this.date.strat) +"00:00:00";
      this.params.endTime = getDate(this.date.end) +"23:59:59";

    },
    getProType() {
      this.proType = [
        {
          id: 1,
          name: '消防'
        },
        {
          id: 2,
          name: '新能源'
        }
      ]
    },
    fileExport(){

      if(this.projectList.length == 0){
        this.$message.warning('请选择要导出的数据');
        return;
      }

      let projectIds = [];
      this.projectList.forEach(item=>{
        projectIds.push(item.id)
      })

      let param = {
        ...this.params,
        projectIds:[...projectIds]
      }
// EXPORTPROJECT
      axios({
        method:'post',
        headers: { 'Authorization':localStorage.getItem('YunWeiTikenBRJ') },
        responseType: 'arraybuffer',
        url:operate.EXPORTPROJECT,
        data:param
      }).then(res=>{
        console.log('导出',res)
        if(!!res && res.status == 200){
          downFile(res.data,'项目管理','xlsx')
        }else if(!!res){
          this.$message.warning(res.message)
        }
      }).catch(err=>{
        console.log('报错',err);
        this.$message.warning(err.message);
      })
    }
  }
}
</script>

<style>

</style>